import * as React from "react";
import Navbar from './Navbar.jsx';
import Header from './Header.jsx';
import Main from './Main.jsx';
import Footer from './Footer.jsx';
import Testimonials from "../../Desktop/Testimonials.jsx";

function About() {
  return (
    <div className="min-h-screen w-full bg-background">
      <Navbar />
      <Header />
      <Main />
      <Testimonials />
      <Footer />
    </div>
  );
}

export default About;